import {TermsOfServicePage as TermsOfService} from './TermsOfService';
export default TermsOfService;
